import album from '@/components/album'
import blog from '@/components/blog'
import readBlog from '@/components/readBlog'
import about from '@/components/about'
import login from '@/components/dashboard/login'
import dashboard from '@/components/dashboard/dashboard'

const homeChildrenRouter = [
  {
    path: '/',
    name: 'album',
    component: album,
  },
  {
    path: '/blog',
    name: 'blog',
    component: blog,
  },
  {
    path: '/blog/:id',
    component: readBlog,
  },
  {
    path: '/about',
    name: 'about',
    component: about,
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: dashboard,
  },
]

export default homeChildrenRouter



// WEBPACK FOOTER //
// ./src/router/home.js